import { BRACKET_PREVIEW_ACTION } from "core/constants/Actions";
import { Action } from "core/models/ActionTypes";
import { BracketPreview } from "core/models/BracketPreview";

const initialState: {
  bracketPreview: BracketPreview | null;
  isLoading: boolean;
} = {
  bracketPreview: null,
  isLoading: false,
};

interface ActionType extends Action {
  payload: {
    bracketPreview: BracketPreview;
  };
}

export default function bracketPreviewDetailReducer(
  state = initialState,
  action: ActionType
) {
  switch (action.type) {
    case BRACKET_PREVIEW_ACTION.REQUEST:
      return { ...state, isLoading: true };

    case BRACKET_PREVIEW_ACTION.SUCCESS:
      const { bracketPreview } = action.payload;
      return { ...state, bracketPreview, isLoading: false };

    case BRACKET_PREVIEW_ACTION.FAILURE:
      return { ...state, ...initialState };

    default:
      return state;
  }
}
